const parseImages = (images) => {

    if (!images) return [];

    try {

        if (typeof images === 'string') {

            // MULTIPLE IMAGES
            if (images.startsWith('[')) {
                return JSON.parse(images);
            }

            // OLD SINGLE IMAGE
            return [images];
        }

        return [];

    } catch (error) {

        console.error('Image parse error:', error);

        return [];
    }
};

export default parseImages;